(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-list-item"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll('.accordion-checkbox');

    accordions.forEach((accordion) => {
      accordion.addEventListener('change', function() {
        const content = this.parentElement.querySelector('.tab__content');
        const video = content.querySelector('video');

        if (this.checked) {
          // Close all other accordions
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== this) {
              otherAccordion.checked = false;
              const otherContent = otherAccordion.parentElement.querySelector('.tab__content');
              const otherVideo = otherContent.querySelector('video');
              otherContent.style.maxHeight = 0;

              // Pause the video in the other accordion if it exists
              if (otherVideo) {
                otherVideo.pause();
              }
            }
          });
          // Open the current accordion
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          // Close the current accordion
          content.style.maxHeight = 0;

          // Pause the video in the current accordion if it exists
          if (video) {
            video.pause();
          }
        }
      });
    });

    // Initialize correct maxHeight on page load
    accordions.forEach((accordion) => {
      const content = accordion.parentElement.querySelector('.tab__content');
      const video = content.querySelector('video');
      if (accordion.checked) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = 0;

        // Pause the video if accordion is closed on page load
        if (video) {
          video.pause();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !window.DesignMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      }
      this.elements.button.addEventListener('click', this.openSelector.bind(this))
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false')
      this.elements.panel.setAttribute('hidden', true)
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return

      this.hidePanel()
      this.elements.button.focus()
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }

    openSelector() {
      this.elements.button.focus()
      this.elements.panel.toggleAttribute('hidden')
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString())
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel()
      }
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const productRecommendationsAddtoCardPreview = () => {
        document.querySelectorAll(".card-send-btn.js-go-cart-add-to-cart").forEach((item) => {
          item.addEventListener("click", function () {
            item.classList.add("adding")
            item.setAttribute("disabled", true)
            setTimeout(function () {
              item.classList.remove("adding")
              item.removeAttribute("disabled", false)
              item.parentNode.classList.remove("open")
              item.parentNode.parentNode.parentNode.classList.remove("open")
              item.parentNode.firstElementChild.classList.remove("open")
              item.previousElementSibling.classList.remove("hide-btn")
            }, 2000);
          })
        })
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            productRecommendationsAddtoCardPreview();

            //Preview product card slider -- global js
            previewCardSlider()
            // chnage image card when hover color swatcher -- global.js
            chnageImageCardProdactPreview()
            //Select size preview card
            chooseSizeCard()


          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-alsolike"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

	var swiper = new Swiper(".collectionproduct-slider", {
		slidesPerView: 6,
		spaceBetween: 30,
		freeMode: true,
		loop: true,
		breakpoints: {
			1400: {
				slidesPerView: 6
			},
			1024: {
				slidesPerView: 4
			},
			991: {
				slidesPerView: 4
			},
			768: {
				slidesPerView: 3
			},
			320: {
				slidesPerView: 2
			}
		}
	});

}); // end DOMContentLoaded


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    let currentCardIndex = 0;
    const cards = $('.we-card');
    const texts = $('.ingredients--text');
    const totalCards = cards.length;

    function calculateIndex(offset) {
      return (currentCardIndex + offset + totalCards) % totalCards;
    }

    function updateClasses() {
      const stateClasses = ['active', 'prev-1', 'next-1', 'prev-2', 'next-2', 'prev-3', 'next-3'];

      // Clear all state classes
      cards.removeClass(stateClasses.join(' '));

      // Apply updated state classes
      $(cards[currentCardIndex]).addClass('active');
      $(cards[calculateIndex(-1)]).addClass('prev-1');
      $(cards[calculateIndex(1)]).addClass('next-1');
      $(cards[calculateIndex(-2)]).addClass('prev-2');
      $(cards[calculateIndex(2)]).addClass('next-2');
      $(cards[calculateIndex(-3)]).addClass('prev-3');
      $(cards[calculateIndex(3)]).addClass('next-3');
    }

    function updateTexts() {
      texts.hide();
      $(texts[currentCardIndex]).show();
    }

    function updateCarousel() {
      updateClasses();
      updateTexts();
    }

    // Initialize carousel
    updateCarousel();

    // Event listeners
    $('.right').click(function () {
      currentCardIndex = calculateIndex(1);
      updateCarousel();
    });

    $('.left').click(function () {
      currentCardIndex = calculateIndex(-1);
      updateCarousel();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
